import axios from "axios";
import { gapi } from "./api.js";
import str from '../index.js';
const url = gapi + "cities";


const cities = {
  namespaced: true,
  state: {
    msg:null,
    cityAll: [],
 
  },
  getters: {
    GET_ALLDATA: (state) => {
      return state.cityAll;
    },
    getTodoById: (state) => (id) => {
      return state.cityAll.find((todo) => todo.id == id);
    },
    getMsg: (state) => {
      return state.msg;
    }
  },
  mutations: {
    SET_DATA(state, data) {
      state.cityAll = data;
    },

    ADD_DATA(state, data) {

      state.cityAll.unshift(data);
    },
  
    UPDATE_DATA(state, data) { 
      const index = state.cityAll.findIndex((t) => t.id === data.id);
  
      var dts = {
        id : data.id ,
        cName : data.cName 
                     }
      if (index !== -1) {
        state.cityAll.splice(index, 1, dts);
      }
    },
    DELETE_DATA(state, data) {
      state.cityAll = state.cityAll.filter((t) => data.id !== t.id);
    },STATE_CRUD(state,data){
      var num = data;
      num = num.toString().replace( /^\D+/g, '');
      state.msg = num;
    }
  }
  ,
  actions: {

    async fetchData({ commit }) {
      await axios
        .get(url,{headers:{Authorization: str.state.token}})
        .then((res) => {
          commit("SET_DATA", res.data.data);
          // console.log(res.data.data)
        })
        .catch((error) => {console.log(error)
            commit("STATE_CRUD", error)
        });
    }, // get all data view with reletion
  
    // add student
    async addData({ commit }, data) {
      await axios
        .post(url, data,{headers:{Authorization: str.state.token}})
        .then((res) => {
          commit("ADD_DATA", res.data.data);
         
        })
        .catch((error) => {
        console.log(error)
        commit("STATE_CRUD", error)
      });
    },
    // get student to edit
    async getData(id) {
      await axios
        .get(url + "/" + id,{headers:{Authorization: str.state.token}})
        .then((res) => {
          return res.data.data;

        })
        .catch((error) => {
            console.log(error);
        });
    },
    // update student
   async  updateData({ commit }, data) {

      var app = url + "/" + data.id;
      await axios
        .put(app, data,{headers:{Authorization: str.state.token}})
        .then(
         
          commit("UPDATE_DATA", data)
        
       )
        .catch((error) =>{ console.log(error)
         
         
          commit("STATE_CRUD", error)
    });
    
    },

    async deleteData({ commit }, data) {
      var app = url + "/" + data.id;
      await axios
        .delete(app,{headers:{Authorization: str.state.token}})
        .then(
          commit("DELETE_DATA", data)
 
        )
        .catch((error) => {
            commit("STATE_CRUD", error)
        });
    },
  },
};
export default cities;
